<template>
  <div class="flex flex-col h-full">
    <div class="p-16 border-b border-grey-divider-subdued">
      <h2 class="text-h4">Messages</h2>
    </div>
    <div class="flex-1 overflow-y-auto">
      <div v-if="loading">
        <ChannelListSkeleton />
      </div>
      <div v-else-if="channels.length === 0">
        <EmptyStateCard
          class="ml-16"
          :title="emptyTitle"
          :message="emptyMessage"
          :actionText="emptyActionText"
          :actionUrl="emptyActionUrl"
          :actionTo="emptyActionTo"
          @action="$emit('emptyAction')"
        />
      </div>
      <div v-else class="flex flex-col">
        <ChannelListItem
          v-for="channel in channels"
          :key="channel.url"
          :channelUrl="channel.url"
          :name="channel.name"
          :avatarUrl="channel.avatarUrl"
          :lastMessage="channel.lastMessage"
          :lastMessageAt="channel.lastMessageAt"
          :unreadCount="channel.unreadCount"
          :isActive="channel.url === selectedChannelUrl"
          @select="$emit('select', $event)"
          @prefetch="$emit('prefetch', channel.url)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { RawLocation } from 'vue-router';
import EmptyStateCard from '@/components/empty_state_card/EmptyStateCard.vue';
import ChannelListItem from '@/apps/messages/components/channelList/ChannelListItem.vue';
import ChannelListSkeleton from '@/apps/messages/components/channelList/ChannelListSkeleton.vue';

interface ChannelListItemData {
  url: string;
  name: string;
  avatarUrl?: string;
  lastMessage?: string;
  lastMessageAt?: string;
  unreadCount?: number;
}

export default {
  name: 'ChannelList',
  components: {
    EmptyStateCard,
    ChannelListItem,
    ChannelListSkeleton,
  },
  props: {
    channels: {
      type: Array as PropType<ChannelListItemData[]>,
      default: () => [],
    },
    selectedChannelUrl: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyTitle: {
      type: String,
      default: 'No messages',
    },
    emptyMessage: {
      type: String,
      default: 'Your conversations with sitters will appear here',
    },
    emptyActionText: {
      type: String,
      default: '',
    },
    emptyActionUrl: {
      type: String,
      default: '',
    },
    emptyActionTo: {
      type: [String, Object] as PropType<RawLocation>,
      default: null,
    },
  },
};
</script>
